import React from 'react';
import { DirectoryContextProvider } from '../../context/directoryManagementContext';
import Result from '../../Components/chatModule/Result';

const Chat = () => {
  return (
    <DirectoryContextProvider>
        <Result />
    </DirectoryContextProvider>
  );
};

export default Chat;
